var __jsx = React.createElement;
import React from "react";
var CustomUserMessage = function CustomUserMessage(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-start mb-4 justify-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-x-2 rounded-t-lg bg-gray-600 px-4 py-2 text-sm font-semibold text-white dark:bg-gray-700"
  }, "You"), /*#__PURE__*/React.createElement("div", {
    className: "rounded-b-md  rounded-tl-md bg-gray-200 px-5 py-2 text-gray-700 dark:bg-white dark:text-gray-800 text-right"
  }, /*#__PURE__*/React.createElement("p", {
    className: "whitespace-pre-wrap"
  }, props.message))));
};
export default CustomUserMessage;